module.exports = __webpack_public_path__ + "static/assets/7a48882204eb3dab70be34b1be1098e6.png";